import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'

export function useRequestStats() {
  const { getToken } = useAuthenticatedUser()

  return useQuery({
    queryKey: ['dashboard-requests-stats'],
    queryFn: async () => {
      const authorization = await getToken()
      const requestsClient = new RequestsHttpClient({ authorization })
      const { data, error } = await requestsClient.GET('/get-stats')
      throwIfApiError(error)
      return data
    },
  })
}
